module.exports = __webpack_public_path__ + "img/iconDownloadGreen.80f06509.svg";